/**
 * Staggered Split-Text-Reveal, ohne Library.
 *
 * data-split-reveal   Container: bekommt .is-split (Wörter versteckt,
 *                     scharfgestellt) und beim Eintritt in den Viewport
 *                     .is-inview (Reveal läuft)
 * data-split-text     Textelement im Container: Wörter werden in
 *                     Masken-Spans zerlegt und über --split-index gestaffelt
 *
 * <br> und Inline-Spans (z.B. .block-title-highlight) bleiben erhalten;
 * bei prefers-reduced-motion passiert nichts (Text bleibt statisch).
 */

const containers = [...document.querySelectorAll('[data-split-reveal]')]

const splitElement = (el) => {
  let index = 0

  const wrapWords = (node) => {
    if (node.nodeType === Node.TEXT_NODE) {
      const fragment = document.createDocumentFragment()

      node.textContent.split(/(\s+)/).forEach((part) => {
        if (!part) return

        if (/^\s+$/.test(part)) {
          fragment.append(part)
          return
        }

        const mask = document.createElement('span')
        mask.className = 'split-word'

        const word = document.createElement('span')
        word.className = 'split-word-text'
        word.style.setProperty('--split-index', index++)
        word.textContent = part

        mask.append(word)
        fragment.append(mask)
      })

      node.replaceWith(fragment)
      return
    }

    if (node.nodeType === Node.ELEMENT_NODE && node.tagName !== 'BR') {
      ;[...node.childNodes].forEach(wrapWords)
    }
  }

  ;[...el.childNodes].forEach(wrapWords)
}

if (containers.length && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  const observer = new IntersectionObserver(
    (entries) => {
      entries
        .filter((entry) => entry.isIntersecting)
        .forEach((entry) => {
          entry.target.classList.add('is-inview')
          observer.unobserve(entry.target)
        })
    },
    { rootMargin: '0px 0px -15% 0px' }
  )

  containers.forEach((container) => {
    container.querySelectorAll('[data-split-text]').forEach(splitElement)
    container.classList.add('is-split')
    observer.observe(container)
  })
}
